try {
        let wrapper = document.querySelector('[data-bnode="beae-vqecxb"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-vqecxb",
              env = "live";
            
    const scrollSmooth = (targetId) => {
      const target = document.querySelector('[data-bnode="' + targetId + '"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return !!target;
    };

    wrapper.addEventListener('click', (e) => {
      const h = wrapper.getAttribute('href');
      if (h && h.startsWith('#') && h !== '#') {
        if (scrollSmooth(h.substring(1))) e.preventDefault();
      }
    });

    if (window.location.hash && !window.beaeScrollHashHandled) {
      window.beaeScrollHashHandled = true;
      setTimeout(() => scrollSmooth(window.location.hash.substring(1)), 300);
    }
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-er9eyw"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-er9eyw",
              env = "live";
            
    const debounce = (fn, delay) => {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    };
    const getType = () => {
      const w = window.innerWidth;
      if (w <= 766) return "mobile";
      if (w <= 1180) return "tablet";
      return "desktop";
    };
    let currentType = "";
    const updateVideo = () => {
      const videoEl = wrapper.querySelector(".beae-video-background");
      if(!videoEl) return
      videoEl.muted = true;
      const type = getType();
      if (type === currentType) return;
      currentType = type;
      const source = videoEl.querySelector("source");
      if (!source) return;
      const newSrc = videoEl.dataset[type] || videoEl.dataset.desktop;
      if (!newSrc) return;
      if (source.getAttribute("src") !== newSrc) {
        source.setAttribute("src", newSrc);
        videoEl.load();
      }
    }
    updateVideo();
    window.addEventListener("resize", debounce(updateVideo, 200));
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-v2va0a"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-v2va0a",
              env = "live";
            
    const debounce = (fn, delay) => {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    };
    const getType = () => {
      const w = window.innerWidth;
      if (w <= 766) return "mobile";
      if (w <= 1180) return "tablet";
      return "desktop";
    };
    let currentType = "";
    const updateVideo = () => {
      const videoEl = wrapper.querySelector(".beae-video-background");
      if(!videoEl) return
      videoEl.muted = true;
      const type = getType();
      if (type === currentType) return;
      currentType = type;
      const source = videoEl.querySelector("source");
      if (!source) return;
      const newSrc = videoEl.dataset[type] || videoEl.dataset.desktop;
      if (!newSrc) return;
      if (source.getAttribute("src") !== newSrc) {
        source.setAttribute("src", newSrc);
        videoEl.load();
      }
    }
    updateVideo();
    window.addEventListener("resize", debounce(updateVideo, 200));
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-bpkbjn"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-bpkbjn",
              env = "live";
            
    const debounce = (fn, delay) => {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    };
    const getType = () => {
      const w = window.innerWidth;
      if (w <= 766) return "mobile";
      if (w <= 1180) return "tablet";
      return "desktop";
    };
    let currentType = "";
    const updateVideo = () => {
      const videoEl = wrapper.querySelector(".beae-video-background");
      if(!videoEl) return
      videoEl.muted = true;
      const type = getType();
      if (type === currentType) return;
      currentType = type;
      const source = videoEl.querySelector("source");
      if (!source) return;
      const newSrc = videoEl.dataset[type] || videoEl.dataset.desktop;
      if (!newSrc) return;
      if (source.getAttribute("src") !== newSrc) {
        source.setAttribute("src", newSrc);
        videoEl.load();
      }
    }
    updateVideo();
    window.addEventListener("resize", debounce(updateVideo, 200));
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-6utpqg"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-6utpqg",
              env = "live";
            
    function debounce(fn, delay = 300) {
        let timeout;

        return function (...args) {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                fn.apply(this, args);
            }, delay);
        };
    }

    function initAccordion() {
      let rootNode = wrapper && wrapper.matches && wrapper.matches('[data-beae-accordion-root]')
        ? wrapper : wrapper.querySelector('[data-beae-accordion-root]');
      
      if (!rootNode) return;

      const items = Array.from(rootNode.querySelectorAll('.beae-accordion-item'));
      const type = rootNode.getAttribute('data-type');
      const defaultSetting = rootNode.getAttribute('data-default');

      const animateClose = (item) => {
        const summary = item.querySelector('summary');
        item.style.height = item.offsetHeight + 'px'; 
        item.setAttribute('data-beae-active', 'false');
        
        requestAnimationFrame(() => {
          item.style.transition = "height 0.25s ease";
          item.style.height = summary.offsetHeight + 'px';
        });

        setTimeout(() => {
          if (item.getAttribute('data-beae-active') === 'false') {
            item.open = false;
            item.style.height = ''; 
            item.style.transition = ""; // Reset transition
          }
        }, 250);
      };

      const animateOpen = (item) => {
        const summary = item.querySelector('summary');
        const content = item.querySelector('.beae-accordion-content');
        const startHeight = summary.offsetHeight;
        
        item.open = true;
        item.setAttribute('data-beae-active', 'true');
        const endHeight = startHeight + content.scrollHeight;
        
        item.style.height = startHeight + 'px';
        
        requestAnimationFrame(() => {
          item.style.transition = "height 0.25s ease";
          item.style.height = endHeight + 'px';
        });

        setTimeout(() => {
          if (item.getAttribute('data-beae-active') === 'true') {
            item.style.height = 'auto'; 
            item.style.transition = ""; 
          }
        }, 250);
      };

      if (type === 'single') {
        const activeItems = items.filter(item => item.getAttribute('data-beae-active') === 'true');
        
        let hasSelectedOne = false;

        items.forEach((item, idx) => {
          const summary = item.querySelector('summary');
          const content = item.querySelector('.beae-accordion-content');
          
          const shouldBeOpen = activeItems.length > 0 
            ? (item === activeItems[0]) 
            : (defaultSetting === 'first' && idx === 0);

          if (shouldBeOpen && !hasSelectedOne) {
            item.open = true;
            item.setAttribute('data-beae-active', "true");
            item.style.height = 'auto';
            hasSelectedOne = true;
          } else {
            item.open = false;
            item.setAttribute('data-beae-active', "false");
            item.style.height = summary.offsetHeight + 'px';
          }
        });
      } else {
        items.forEach((item, idx) => {
          const summary = item.querySelector('summary');
          const shouldOpen = (defaultSetting === 'all') || (defaultSetting === 'first' && idx === 0) || (item.getAttribute('data-beae-active') === 'true');
          
          if (shouldOpen) {
            item.open = true;
            item.setAttribute('data-beae-active', 'true');
            item.style.height = 'auto';
          } else {
            item.open = false;
            item.setAttribute('data-beae-active', 'false');
            item.style.height = summary.offsetHeight + 'px';
          }
        });
      }

      items.forEach(item => {
        const summary = item.querySelector('summary');
        summary.onclick = (e) => {
          e.preventDefault();
          const currentType = rootNode.getAttribute('data-type');
          const isOpening = !item.open || item.getAttribute('data-beae-active') === 'false';

          if (currentType === 'single') {
            if (isOpening) {
              items.forEach(other => {
                if (other !== item && other.open) animateClose(other);
              });
              animateOpen(item);
            } else {
              animateClose(item);
            }
          } else {
            isOpening ? animateOpen(item) : animateClose(item);
          }
        };
      });
    }

    initAccordion();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(m => {
        if (m.attributeName === 'data-type' || m.attributeName === 'data-default') {
          initAccordion();
        }
      });
    });

    const target = wrapper && wrapper.matches && wrapper.matches('[data-beae-accordion-root]') 
      ? wrapper : wrapper.querySelector('[data-beae-accordion-root]');

    if (target) {
      observer.observe(target, { attributes: true });
    }

    const handleResize = debounce(() => {
        initAccordion();
    }, 200);

    window.addEventListener("resize", handleResize);
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-8pal6y"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-8pal6y",
              env = "live";
            
    const scrollSmooth = (targetId) => {
      const target = document.querySelector('[data-bnode="' + targetId + '"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return !!target;
    };

    wrapper.addEventListener('click', (e) => {
      const h = wrapper.getAttribute('href');
      if (h && h.startsWith('#') && h !== '#') {
        if (scrollSmooth(h.substring(1))) e.preventDefault();
      }
    });

    if (window.location.hash && !window.beaeScrollHashHandled) {
      window.beaeScrollHashHandled = true;
      setTimeout(() => scrollSmooth(window.location.hash.substring(1)), 300);
    }
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-l7p8k7"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-l7p8k7",
              env = "live";
            
    const debounce = (fn, delay) => {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    };
    const getType = () => {
      const w = window.innerWidth;
      if (w <= 766) return "mobile";
      if (w <= 1180) return "tablet";
      return "desktop";
    };
    let currentType = "";
    const updateVideo = () => {
      const videoEl = wrapper.querySelector(".beae-video-background");
      if(!videoEl) return
      videoEl.muted = true;
      const type = getType();
      if (type === currentType) return;
      currentType = type;
      const source = videoEl.querySelector("source");
      if (!source) return;
      const newSrc = videoEl.dataset[type] || videoEl.dataset.desktop;
      if (!newSrc) return;
      if (source.getAttribute("src") !== newSrc) {
        source.setAttribute("src", newSrc);
        videoEl.load();
      }
    }
    updateVideo();
    window.addEventListener("resize", debounce(updateVideo, 200));
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-t68z5e"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-t68z5e",
              env = "live";
            
    const debounce = (fn, delay) => {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    };
    const getType = () => {
      const w = window.innerWidth;
      if (w <= 766) return "mobile";
      if (w <= 1180) return "tablet";
      return "desktop";
    };
    let currentType = "";
    const updateVideo = () => {
      const videoEl = wrapper.querySelector(".beae-video-background");
      if(!videoEl) return
      videoEl.muted = true;
      const type = getType();
      if (type === currentType) return;
      currentType = type;
      const source = videoEl.querySelector("source");
      if (!source) return;
      const newSrc = videoEl.dataset[type] || videoEl.dataset.desktop;
      if (!newSrc) return;
      if (source.getAttribute("src") !== newSrc) {
        source.setAttribute("src", newSrc);
        videoEl.load();
      }
    }
    updateVideo();
    window.addEventListener("resize", debounce(updateVideo, 200));
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-jtuc2y"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-jtuc2y",
              env = "live";
            
 const counterElement = wrapper.querySelector(".beae-count");

 const start = Number(wrapper.dataset.start) || 0;
 const end = Number(wrapper.dataset.end) || 0;
 const duration = Number(Math.abs(wrapper.dataset.duration)) || 2000;

 const startTime = Date.now();

 function updateCounter() {
 const elapsed = Date.now() - startTime;
 const progress = Math.min(elapsed / duration, 1);

 const current = Math.round(start + (end - start) * progress);

 if (counterElement) {
 counterElement.textContent = current;
 }

 if (progress < 1) {
 requestAnimationFrame(updateCounter);
 }
 }

 updateCounter();
 
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-gky8fx"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-gky8fx",
              env = "live";
            
    const debounce = (fn, delay) => {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    };
    const getType = () => {
      const w = window.innerWidth;
      if (w <= 766) return "mobile";
      if (w <= 1180) return "tablet";
      return "desktop";
    };
    let currentType = "";
    const updateVideo = () => {
      const videoEl = wrapper.querySelector(".beae-video-background");
      if(!videoEl) return
      videoEl.muted = true;
      const type = getType();
      if (type === currentType) return;
      currentType = type;
      const source = videoEl.querySelector("source");
      if (!source) return;
      const newSrc = videoEl.dataset[type] || videoEl.dataset.desktop;
      if (!newSrc) return;
      if (source.getAttribute("src") !== newSrc) {
        source.setAttribute("src", newSrc);
        videoEl.load();
      }
    }
    updateVideo();
    window.addEventListener("resize", debounce(updateVideo, 200));
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-6d8kg2"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-6d8kg2",
              env = "live";
            
    const debounce = (fn, delay) => {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    };
    const getType = () => {
      const w = window.innerWidth;
      if (w <= 766) return "mobile";
      if (w <= 1180) return "tablet";
      return "desktop";
    };
    let currentType = "";
    const updateVideo = () => {
      const videoEl = wrapper.querySelector(".beae-video-background");
      if(!videoEl) return
      videoEl.muted = true;
      const type = getType();
      if (type === currentType) return;
      currentType = type;
      const source = videoEl.querySelector("source");
      if (!source) return;
      const newSrc = videoEl.dataset[type] || videoEl.dataset.desktop;
      if (!newSrc) return;
      if (source.getAttribute("src") !== newSrc) {
        source.setAttribute("src", newSrc);
        videoEl.load();
      }
    }
    updateVideo();
    window.addEventListener("resize", debounce(updateVideo, 200));
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-s8cqu0"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-s8cqu0",
              env = "live";
            
    const scrollSmooth = (targetId) => {
      const target = document.querySelector('[data-bnode="' + targetId + '"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return !!target;
    };

    wrapper.addEventListener('click', (e) => {
      const h = wrapper.getAttribute('href');
      if (h && h.startsWith('#') && h !== '#') {
        if (scrollSmooth(h.substring(1))) e.preventDefault();
      }
    });

    if (window.location.hash && !window.beaeScrollHashHandled) {
      window.beaeScrollHashHandled = true;
      setTimeout(() => scrollSmooth(window.location.hash.substring(1)), 300);
    }
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-nqcw3g"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-nqcw3g",
              env = "live";
            
    const debounce = (fn, delay) => {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    };
    const getType = () => {
      const w = window.innerWidth;
      if (w <= 766) return "mobile";
      if (w <= 1180) return "tablet";
      return "desktop";
    };
    let currentType = "";
    const updateVideo = () => {
      const videoEl = wrapper.querySelector(".beae-video-background");
      if(!videoEl) return
      videoEl.muted = true;
      const type = getType();
      if (type === currentType) return;
      currentType = type;
      const source = videoEl.querySelector("source");
      if (!source) return;
      const newSrc = videoEl.dataset[type] || videoEl.dataset.desktop;
      if (!newSrc) return;
      if (source.getAttribute("src") !== newSrc) {
        source.setAttribute("src", newSrc);
        videoEl.load();
      }
    }
    updateVideo();
    window.addEventListener("resize", debounce(updateVideo, 200));
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };try {
        let wrapper = document.querySelector('[data-bnode="beae-ludjt3"]');
        if (wrapper) {
          if (!wrapper.getAttribute('data-executed-scripts')) {
            wrapper.setAttribute('data-executed-scripts', true);
            let id = "beae-ludjt3",
              env = "live";
            
    const debounce = (fn, delay) => {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    };
    const getType = () => {
      const w = window.innerWidth;
      if (w <= 766) return "mobile";
      if (w <= 1180) return "tablet";
      return "desktop";
    };
    let currentType = "";
    const updateVideo = () => {
      const videoEl = wrapper.querySelector(".beae-video-background");
      if(!videoEl) return
      videoEl.muted = true;
      const type = getType();
      if (type === currentType) return;
      currentType = type;
      const source = videoEl.querySelector("source");
      if (!source) return;
      const newSrc = videoEl.dataset[type] || videoEl.dataset.desktop;
      if (!newSrc) return;
      if (source.getAttribute("src") !== newSrc) {
        source.setAttribute("src", newSrc);
        videoEl.load();
      }
    }
    updateVideo();
    window.addEventListener("resize", debounce(updateVideo, 200));
  
          }
        }
      } catch (ex) { console.error('Beae Editor JS Error: ' + ex.message) };

// Override Beae's counter init
var style = document.createElement('style');
style.textContent = '.beae-counter-wrapper { visibility: hidden; }';
document.head.appendChild(style);
document.addEventListener("DOMContentLoaded", function () {
  var counter = document.getElementById("beae-counter");
  if (!counter) return;

  var countEl = counter.querySelector(".beae-count");
  if (!countEl) return;

  var end = parseInt(counter.closest("[data-end]") ? counter.closest("[data-end]").getAttribute("data-end") : 40);
  var duration = 3000;
  var started = false;

  function animateCount() {
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      countEl.textContent = Math.floor(progress * end);
      if (progress < 1) {
        counter.closest('.beae-counter-wrapper').style.visibility = 'visible';
requestAnimationFrame(step);
      } else {
        countEl.textContent = end;
      }
    }
    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !started) {
        started = true;
        countEl.textContent = "0";
        animateCount();
      }
    });
  }, { threshold: 0.9, rootMargin: "0px 0px -200px 0px" });

  observer.observe(counter);
}); 
    (function () {
  var FIXED_TOTAL = '$99.00';

  function setTotal() {
    var el = document.querySelector('.gbbFooterTotalValueContainer');
    if (el && el.textContent.trim() !== FIXED_TOTAL) {
      el.textContent = FIXED_TOTAL;
    }
  }

  setTotal();
  document.addEventListener('DOMContentLoaded', setTotal);

  var observer = new MutationObserver(setTotal);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();                       